export default {
  checkIn: {
    aboutVisit: {
      am: 'am',
      at: 'at',
      choose: 'Choose',
      hour: 'Hour',
      meridian: 'am/pm',
      min: 'Min',
      pleaseEnterAValidTimeAndDate: 'Please enter a valid time and date',
      pm: 'pm',
      timeCantBeFuture: "Date/time can't be in the future",
      today: 'Today',
      yesterday: 'Yesterday'
    },
    checkIn: {
      info: 'Some info goes here...',
      browserOutdated: 'Your browser is out-of-date. Please upgrade to a {0}modern web browser{1}.'
    },
    digitalReceipt: {
      currency: '£',
      description: 'Description',
      discount: 'Discount',
      emailReceipt: 'Email the receipt',
      mealReceipt: 'Meal receipt',
      price: 'Price',
      save: 'Save',
      server: 'Server',
      serviceCharge: 'Service charge',
      tableNumber: 'Table number',
      total: 'Total',
      yourEmail: 'Your email'
    },
    errors: {
      noSlug: 'No survey tag passed',
      badSlug: 'Bad survey tag used'
    },
    guestTableNumberEntry: {
      mustBeANumber: 'Table number must be a number',
      pleaseEnterTableNumber: 'Please enter your table number so we can find your order',
      tableNumber: 'Table number',
      yourTableNumber: 'Your Table number'
    },
    locationCheckIn: {
      checkIn: 'Check in',
      freeDesertOnYourNextVisit: 'Free dessert on your next visit',
      pleaseTellUsAboutYourExperience: "Please tell us about your experience - it'll take less than a minute!"
    },
    teamMemberReceiptPinEntry: {
      downloadingTransactionData: 'Downloading transaction data',
      enterPinNumber: 'Enter PIN number',
      pinNumber: 'PIN number'
    },
    teamMemberTableNumberEntry: {
      downloadingTransactionData: 'Downloading transaction data',
      mustBeANumber: 'Table number must be a number',
      pleaseEnterTableNumber: 'Please enter the table number to download transaction data',
      tableNumber: 'Table number',
      noNumber: 'Not got a table number?'
    }
  }
};